import React from 'react';
import { CloseIcon } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * Simple "push notification" like view
 * so it's just a bubble in bottom-right position
 * which is used for show/hide logic
 */
export default class NotifierPopup extends React.PureComponent {
  state = {
    showContent: true,
  };

  componentDidUpdate(prevProps) {
    const { opened } = this.props;
    if (!opened && opened !== prevProps.opened && this.state.showContent) {
      setTimeout(this.hideContent.bind(this), 300);
    }
  }

  hideContent = () => this.setState({ showContent: false });

  render() {
    const { children, className, isMobile, noCloseButton, onClose, opened } = this.props;
    const { showContent } = this.state;
    return (
      <div className={cx('overlay', { isMobile }, opened ? 'opened' : 'closed')}>
        <div className={cx('component', className)}>
          <button
            className={cx('cross', 'notifyCloseButton', { noCloseButton })}
            name="Закрыть"
            onClick={onClose}
            type="button"
          >
            <CloseIcon className={cx('icon')} fill="#727281" size="m" />
          </button>
          {showContent && <div className={cx('content')}>{children}</div>}
        </div>
      </div>
    );
  }
}

NotifierPopup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  isMobile: PropTypes.bool,
  noCloseButton: PropTypes.bool,
  onClose: PropTypes.func,
  opened: PropTypes.bool,
};
